import { render, staticRenderFns } from "./SearchTagsFilter.vue?vue&type=template&id=f2f37e32"
import script from "./SearchTagsFilter.vue?vue&type=script&lang=js"
export * from "./SearchTagsFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports